import Vue from "vue";
import App from "./App.vue";
import store from "./store";

new Vue({
  el: "#vue-header",
  render: (h) => h(App),
  store,
});



// WEBPACK FOOTER //
// ./src/main.js